export enum CharityStatus {
  Active = 'Active',
  Archived = 'Archived',
}
